import { Box, SxProps, Theme, Typography } from "@mui/material";

const defaultLabelStyles = {
  fontSize: { xs: "16px", md: "18px", lg: "20px" },
  ml: 0,
  fontWeight: "bold",
  color: "var(--black)",
};

const defaultBoxStyles = {
  width: "100%",
  height: "48px",
  display: "flex",
  alignItems: "center",
  backgroundColor: "var(--primary-500)",
  boxSizing: "border-box",
};

export interface LabelHeaderProps {
  label: string;
  sxBox?: SxProps<Theme>;
  sxTypography?: SxProps<Theme>;
  required?: boolean;
}

/**
 * A component that renders a label header with customizable styles.
 * @param {object} props - The properties object.
 * @param {string} props.label - The text to be displayed as the label.
 * @param {SxProps<Theme>} [props.sxBox] - Optional styling properties to be applied to the container box.
 * @param {SxProps<Theme>} [props.sxTypography] - Optional styling properties to be applied to the typography element.
 * @param {boolean} [props.required] - Optional flag to indicate if the field is required. If true, a "※必須" indicator is shown.
 */
export default function LabelHeader({ label, sxBox, sxTypography, required }: LabelHeaderProps) {
  return (
    <Box
      sx={
        {
          position: "relative",
          ...defaultBoxStyles,
          ...sxBox,
        } as SxProps<Theme>
      }
    >
      {required && (
        <Typography
          sx={{
            color: "var(--red-800)",
            fontSize: { xs: 11, lg: 12 },
            position: "absolute",
            top: "4px",
            left: "4px",
            fontWeight: "medium",
          }}
        >
          ※必須
        </Typography>
      )}
      <Typography sx={{ ...defaultLabelStyles, ...sxTypography }}>{label}</Typography>
    </Box>
  );
}
